import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.08002C12.4142 9.08002 12.75 8.74423 12.75 8.33002C12.75 7.9158 12.4142 7.58002 12 7.58002C11.5858 7.58002 11.25 7.9158 11.25 8.33002C11.25 8.74423 11.5858 9.08002 12 9.08002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V15.66C12.75 16.0742 12.4142 16.41 12 16.41C11.5858 16.41 11.25 16.0742 11.25 15.66V11C11.25 10.5858 11.5858 10.25 12 10.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconInfo as ReactComponent };
